import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/logout',
};

export const logoutRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
